export function lastNDigits(value, n) {
  const str = String(value == null ? "" : value);
  if (!n || n <= 0) return "";
  let out = str.length > n ? str.slice(-n) : str;
  if (out.length < n) {
    out = new Array(n - out.length + 1).join("0") + out;
  }
  return out;
}

export function buildLotNumber(
  supplierNumber,
  itemNumber,
  docNumber,
  supplierItemLotNumber
) {
  const prefix = "35";
  const partItem = lastNDigits(itemNumber, 3);
  const partSupplier = lastNDigits(supplierNumber, 2);
  const partDoc = String(docNumber == null ? "" : docNumber);
  const partSupplierLot = String(
    supplierItemLotNumber == null ? "" : supplierItemLotNumber
  );
  return `${prefix}${partItem}${partSupplier}${partDoc}${partSupplierLot}`;
}
